import { type GiftWithPurchase } from "@tablescape/state";
import { captureException } from "@root/tablescape/utilities/error";

export const getLoyaltyTier = (): string | null => {
  try {
    const customerDetails = window?.swellAPI?.getCustomerDetails();
    if (customerDetails && customerDetails.vipTier) {
      return customerDetails.vipTier.name?.toLowerCase() ?? null;
    } else {
      return (
        document.querySelector<HTMLElement>("[data-loyalty-tier]")?.dataset
          .loyaltyTier ?? null
      );
    }
  } catch (e: unknown) {
    if (e instanceof Error) {
      captureException(e, {
        tags: {
          "function.name": "getLoyaltyTier",
          "issue.type": "loyalty-tier",
        },
      });
    }

    return null;
  }
};

export const isCustomerEligibleForGwp = (
  giftWithPurchase: GiftWithPurchase
) => {
  const loyaltyTier = getLoyaltyTier();
  const { eligibleLoyaltyTiers } = giftWithPurchase;

  if (!eligibleLoyaltyTiers) {
    return true;
  }

  return (
    !!eligibleLoyaltyTiers &&
    !!loyaltyTier &&
    eligibleLoyaltyTiers.includes(loyaltyTier)
  );
};
